import { createSlice } from "@reduxjs/toolkit";

const creditTransferSlice = createSlice({
  name: "creditTransfer",
  initialState: {
    companies: [],
    selectedCompany: null,
    companyUsers: [],
    selectedUser: null,
    userCredit: null,
    isLoadingCompanies: false,
    isLoadingUsers: false,
    isLoadingCredit: false,
    isTransferring: false,
    transferResult: null,
    error: null,
  },
  reducers: {
    setCompanies(state, action) {
      state.companies = action.payload;
      state.isLoadingCompanies = false;
    },
    setSelectedCompany(state, action) {
      state.selectedCompany = action.payload;
      state.companyUsers = [];
      state.selectedUser = null;
      state.userCredit = null;
      state.transferResult = null;
    },
    setCompanyUsers(state, action) {
      state.companyUsers = action.payload;
      state.isLoadingUsers = false;
    },
    setSelectedUser(state, action) {
      state.selectedUser = action.payload;
      state.userCredit = null;
      state.transferResult = null;
    },
    setUserCredit(state, action) {
      state.userCredit = action.payload;
      state.isLoadingCredit = false;
    },
    setTransferring(state, action) {
      state.isTransferring = action.payload;
    },
    setTransferResult(state, action) {
      state.transferResult = action.payload;
      state.isTransferring = false;
    },
    setLoading(state, action) {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    resetTransfer(state) {
      state.selectedCompany = null;
      state.companyUsers = [];
      state.selectedUser = null;
      state.userCredit = null;
      state.transferResult = null;
      state.error = null;
    },
  },
});

export const {
  setCompanies, setSelectedCompany, setCompanyUsers, setSelectedUser,
  setUserCredit,
  setTransferring, setTransferResult, setLoading, setError, resetTransfer,
} = creditTransferSlice.actions;
export default creditTransferSlice.reducer;
